module.exports = __webpack_public_path__ + "img/carteira.86a4bcfd.png";